import React, { useState } from "react";
import TemplateList from "../../../../../customComponents/TemplateList";
import { useCampaignPageView } from "../../CampaignPage.context";
import { Box, Button } from "@mui/material";
import { Tab, Tabs } from "../../../../../components";
import Panel from "../../Panel";
import { TemplatePanelProps } from "./TemplatePanel.types";
import { useTemplatePanel } from "./TemplatePanel.hooks";
import { AutoAwesome } from "@tiny/icons";
import GenerateWithAIDialog from "../../../../../customComponents/GenerateWithAIDialog";
import { useConfigView } from "../../../../../Config.context";

function TemplatePanel(props: TemplatePanelProps) {
  const { selectTemplate } = props;

  const {
    campaignTemplate,
    campaignId,
    details,
    refetchTemplateSections,
    selectCustomTemplate,
    setTemplateEditorType,
    setRefetchTemplateSections,
  } = useCampaignPageView();

  const { activeTab, changeTab } = useTemplatePanel();

  const { config } = useConfigView();
  const { appName } = config || {};

  const [isGenerateDialogOpen, setIsGenerateDialogOpen] = useState(false);

  const getPreviewMainActionName = React.useCallback((sectionName: string) => {
    return sectionName === "Currently selected"
      ? "Edit template"
      : "Use template";
  }, []);

  const handleOpenGenerateDialog = () => {
    setIsGenerateDialogOpen(true);
  };

  const handleCloseGenerateDialog = () => {
    setIsGenerateDialogOpen(false);
    setRefetchTemplateSections([`reload-${Date.now()}`]);
  };

  const handleTemplateGenerated = (html: string, css: string) => {
    console.log("Template generated:", { html, css });
  };

  const handleCustomizeInEditor = (html: string, css: string) => {
    setTemplateEditorType("DRAG_AND_DROP");
    selectTemplate(
      {
        templateHtml: html,
        templateCss: css,
      },
      false,
      "AUTOMATION"
    );
  };

  return (
    <>
      <Panel
        title="Design your email"
        titleMarginBottom={2}
        contentPaddingX={0}
        button={
          appName === "tinyAlbert" ? (
            <Button
              variant="contained"
              startIcon={<AutoAwesome />}
              onClick={handleOpenGenerateDialog}
            >
              Generate with AI
            </Button>
          ) : (
            <></>
          )
        }
      >
        <Box pl={6} pr={6} pt={5} pb={0}>
          <Tabs value={activeTab} onChange={changeTab}>
            <Tab label="Drag & drop" value="dragAndDrop" />
            <Tab label="Custom code" value="customCode" />
          </Tabs>
        </Box>
        <TemplateList
          activeTab={activeTab}
          campaignId={campaignId}
          campaignName={details?.name}
          emptyStateMessage="No templates found matching your selected tags or search keyword. You can create a new template or get started with any of the branded templates or from template library."
          getPreviewMainActionName={getPreviewMainActionName}
          mainActionText="Use"
          onCreateCustomTemplate={selectCustomTemplate}
          onMainActionClick={selectTemplate}
          onPreviewMainActionClick={selectTemplate}
          refetchSections={refetchTemplateSections}
          selectable={false}
          selectedActionText="Edit"
          selectedTemplate={campaignTemplate ?? undefined}
        />
      </Panel>

      <GenerateWithAIDialog
        open={isGenerateDialogOpen}
        onClose={handleCloseGenerateDialog}
        onTemplateGenerated={handleTemplateGenerated}
        onCustomizeInEditor={handleCustomizeInEditor}
      />
    </>
  );
}

export default TemplatePanel;
